import script from "./listTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./listTopic.vue?vue&type=script&setup=true&lang=js"

import "./listTopic.vue?vue&type=style&index=0&id=4856002a&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4856002a"]])

export default __exports__